import api from "../api/api"

export default class {
    constructor(paginationUrl) {
        this.state = {
            paginationUrl: paginationUrl,
            serverPagination: null,
        };
        this.mutations = {
            SET_SERVER_PAGINATION(state, serverPagination) {
                state.serverPagination = serverPagination;
            },
        };
        this.actions = {
            async fetchPaginated(context, itemsPerPage= 10) {
                context.commit('TOGGLE_LOADING');
                let url = `${context.state.paginationUrl}?page_size=${itemsPerPage}&search=${context.rootState.project.currentProject.id}`;
                let response;
                if (context.state.serverPagination && context.state.serverPagination.next) {
                    response = await api.get(context.state.serverPagination.next);
                } else if (!context.state.serverPagination || context.state.serverPagination.count > context.state.items.length) {
                    response = await api.get(url);
                    context.commit('ADD_COUNT', response["data"].count);
                } else {
                    context.commit('TOGGLE_LOADING');
                    return
                }
                context.commit('ADD_ITEMS', response["data"]["results"]);
                context.commit('SET_SERVER_PAGINATION', response["data"]);
                context.commit('TOGGLE_LOADING');
            },
        };
    }
}